import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import MoveForm from "../components/product-movements/MoveForm";
import InfoForm from "../components/product-movements/InfoForm";
import classnames from "classnames";
import Swal from "sweetalert2";

class ProductMovementsExit extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    previa: false,
    previa_form: false,
    previa_url: "",
    previa_url_form: "",
    modalState: false,
    modalInfoState: false,
    working: true,
    workingModal: true,
    observationModalOpen: false,
    toggle: false,
    paginaActual: 0,
    bitacora_movimiento: "",
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    solicitudes: [],
    activeTab: "1",
    buscar: {},
    producto: "",
    cat_productos: [],
    presentacion: "",
    cat_presentacion: [],
    cantidad_lote: { cantidad: "", lote: "" },
    cantidades_lotes: [],
    fabricante: "",
    num_factura: "",
    producto_valido: false,
    producto_sgi: "",
    productos_validados_listados: [],
    tipo_documentos: [],
    tipo_documentos_aux: [],
    tipo_documento_id: "",
    documentos: [],
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getControlledProductsTypeVet();
    this.getMandatoryMovementDocuments();
    this.setListaSolicitudesMovimientoProductos(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "folio_movimiento",
      "establecimiento_envia",
      "establecimiento_recibe",
      "fecha_solicitud",
      "estatus",
      "fecha_vencimiento",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.setListaSolicitudesMovimientoProductos(1);
  // };

  // cargar catalogo de productos tipo veterinario controlados
  getControlledProductsTypeVet = () => {
    Api.loading(true);
    Api.fetch("app/getControlledProductsTypeVet")
      .then((data) => {
        if (data) {
          this.setState({ cat_productos: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getMandatoryMovementDocuments = () => {
    Api.loading(true);
    Api.fetch("app/getMandatoryMovementDocuments")
      .then((data) => {
        if (data) {
          this.setState({ tipo_documentos: data, tipo_documentos_aux: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  handlePrevia = (e) => {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa_form: true, previa_url_form: doc });
  };

  getControlledProductPresentation = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductPresentation?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_presentacion: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getEstablecimientoFabricanteProducto = (producto_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getEstablecimientoFabricanteProducto?producto_id=" + producto_id
    )
      .then((data) => {
        if (data) {
          this.setState({ fabricante: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  //Funcion para cambiar de pagina en el grid de regente
  setListaSolicitudesMovimientoProductos = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/setListaSolicitudesMovimientoProductos?page=" + page + src
    ).then((sol) => {
      this.setState({
        solicitudes: sol.data,
        paginas: sol.last_page,
        registros: sol.total,
        paginaActual: sol.current_page,
        workingGrid: false,
      });
    });
  };

  verifyProduct = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      producto = this.state.producto,
      presentacion = this.state.presentacion,
      bitacora_movimiento = this.state.bitacora_movimiento,
      producto_valido = this.initialState.producto_valido;

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (!producto) {
      this.validateSingleError("producto", "Seleccione");
    }

    if (!presentacion) {
      this.validateSingleError("presentacion", "Seleccione");
    }

    if (cantidadLote.lote && producto && presentacion) {
      Api.loading(true);

      Api.fetch(
        "app/verifyProduct?lote=" +
          cantidadLote.lote +
          "&producto_id=" +
          producto.id +
          "&presentacion_id=" +
          presentacion.id +
          "&establecimiento_id=" +
          bitacora_movimiento.establecimiento_envia_id +
          "&actividad_id=" +
          bitacora_movimiento.actividad_envia_id
      ).then((data) => {
        if (data && Object.keys(data).length > 0) {
          Swal.fire({
            icon: "success",
            title: "¡Producto encontrado!",
            text: "Se ha encontrado producto especificaciones ingresadas",
            confirmButtonText: "Regresar",
            timer: 5000,
          });

          producto_valido = true;

          this.setState({
            producto_valido: producto_valido,
            producto_sgi: data,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "¡Producto no encontrado!",
            text: "No se encontró producto con las especificaciones ingresadas",
            confirmButtonText: "Regresar",
            timer: 5000,
          });
        }
      });
    }
  };

  validateSingleError = (el, msg) => {
    document.getElementById(el + "-error").style.display = "block";
    document.getElementById(el + "-error").innerText = msg;
    document.getElementById(el).classList.add("is-invalid");
  };

  handleListaMovimientosProducutosPage = (e) => {
    this.setListaSolicitudesMovimientoProductos(e.target.value);
  };

  handleModalCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      bitacora_movimiento: "",
      modalState: false,
      modalInfoState: false,
    });
  };

  handleProductChange = (obj) => {
    // reiniciamos presentacion en caso de que tenga un valor, y asignamos otros valores correspondientes al objeto de productos
    let cantidadLote = this.state.cantidad_lote;
    cantidadLote.cantidad = this.initialState.cantidad_lote.cantidad;
    this.setState({
      producto: obj,
      presentacion: this.initialState.presentacion,
      cantidad_lote: cantidadLote,
      producto_valido: this.initialState.producto_valido,
      producto_sgi: this.initialState.producto_sgi,
      cantidades_lotes: this.initialState.cantidades_lotes,
      productos_validados_listados:
        this.initialState.productos_validados_listados,
      fabricante: this.initialState.fabricante,
      // presentacion: this.initialState.presentacion,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("producto");
    this.cleanErrorsValidation("presentacion");
    this.cleanErrorsValidation("fabricante");
    this.cleanErrorsValidation("lote");
    // buscamos la/las presentaciones del producto
    this.getControlledProductPresentation(obj.id);
    this.getEstablecimientoFabricanteProducto(obj.id);
  };

  handleNumFacturaChange = (e) => {
    this.cleanErrorsValidation("num_factura");
    this.setState({ num_factura: e.target.value.toUpperCase() });
  };

  handlePresentationChange = (obj) => {
    // limpamos errores si es que los hay
    this.cleanErrorsValidation("presentacion");
    this.cleanErrorsValidation("lote");

    let cantidadLote = { ...this.state.cantidad_lote };
    cantidadLote.cantidad = "";

    // le damos el valor del objeto de presentación seleccionado a presentacion
    this.setState({
      presentacion: obj,
      producto_valido: this.initialState.producto_valido,
      cantidad_lote: cantidadLote,
      producto_sgi: this.initialState.producto_sgi,
      cantidades_lotes: this.initialState.cantidades_lotes,
      productos_validados_listados:
        this.initialState.productos_validados_listados,
    });
  };

  openModalForm = (evt) => {
    this.setState({ modalState: true });
    //buscamos la bitacora de movimiento
    Api.fetch("app/getBitacoraMovimiento?id=" + evt.target.id)
      .then((data) => {
        if (data) {
          this.setState({
            bitacora_movimiento: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  openModalInfoForm = (evt) => {
    this.setState({ modalInfoState: true });
    //buscamos la bitacora de movimiento
    Api.fetch(
      "app/getBitacoraMovimiento?id=" +
        evt.target.id +
        "&ver_movimiento_completo=" +
        1
    )
      .then((data) => {
        if (data) {
          this.setState({
            bitacora_movimiento: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let movementData = {
      ...this.state,
    };

    delete movementData.cat_presentacion;
    delete movementData.cat_productos;
    delete movementData.collapse;
    delete movementData.activeTab;
    delete movementData.buscar;
    delete movementData.modalState;
    delete movementData.modalInfoState;
    delete movementData.nivelUsuario;
    delete movementData.observationModalOpen;
    delete movementData.paginaActual;
    delete movementData.paginaActual_vi;
    delete movementData.paginas;
    delete movementData.paginas_vi;
    delete movementData.previa_url;
    delete movementData.previa_url_form;
    delete movementData.producto_valido;
    delete movementData.registros;
    delete movementData.registros_vi;
    delete movementData.toggle;
    delete movementData.working;
    delete movementData.workingGrid;
    delete movementData.workingModal;
    delete movementData.previa;
    delete movementData.previa_form;
    delete movementData.solicitudes;
    delete movementData.tipo_documentos;
    delete movementData.cat_actividad;

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      let cantidadesLotes = this.state.cantidades_lotes,
        documentos = this.state.documentos,
        actividad_recibe_id =
          this.state.bitacora_movimiento.actividad_recibe_id,
        num_factura = this.state.num_factura;

      if (result.isConfirmed) {
        if (
          cantidadesLotes.length === 0 ||
          (actividad_recibe_id === "16" && documentos.length === 0) ||
          (actividad_recibe_id === "16" && !num_factura)
        ) {
          if (cantidadesLotes.length === 0) {
            this.fireSwal(
              "¡Debe ingresar por lo menos una cantidad y lote para poder generar el egreso de productos!",
              "warning"
            );
          }

          if (actividad_recibe_id === "16" && documentos.length === 0) {
            this.validateSingleError(
              "tipo_documento",
              "Debe seleccionar ingresar documento requerido."
            );
          }

          if (actividad_recibe_id === "16" && !num_factura) {
            this.validateSingleError(
              "num_factura",
              "Ingrese número de factura."
            );
          }
        } else {
          this.submitForm(movementData);
        }
      }
    });
  };

  handleVistaPrevia = (e) => {
    let file = this.state.documentos[e.target.id].data;
    file = file.substr("data:application/pdf;base64,".length);
    this.setState({ previa: true, previa_url: file });
  };

  handleCloseVistaPrevia = (e) => {
    this.setState({ previa: false });
  };

  submitForm = (movementData) => {
    Api.loading(true);
    Api.fetch("app/storeMovementLogs", movementData, "POST").then((data) => {
      if (data.errors) {
        this.handleValidations(data.errors);
        Api.loading(false);
        this.fireSwal(
          "¡Verifique que los datos esten correctamente completados!",
          "warning"
        );
        return false;
      } else {
        Api.loading(false);
        Swal.fire({
          icon: "success",
          title: "¡La información ha sido almacenada exitosamente!",
          timer: 3000,
          confirmButtonText: "Continuar",
        }).then(() => {
          window.location.href = "/movimientos-productos/egresos";
        });
        this.resetStates();
      }
    });
  };

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      producto: this.initialState.producto,
      presentacion: this.initialState.presentacion,
      bitacora_movimiento: this.initialState.bitacora_movimiento,
      fabricante: this.initialState.fabricante,
      productos_validados_listados:
        this.initialState.productos_validados_listados,
      cantidad_lote: this.initialState.cantidad_lote,
      producto_sgi: this.initialState.producto_sgi,
      cantidades_lotes: this.initialState.cantidades_lotes,
      producto_valido: this.initialState.producto_valido,
      num_factura: this.initialState.num_factura,
      tipo_documentos: this.state.tipo_documentos_aux,
      tipo_documento_id: this.initialState.tipo_documento_id,
      documentos: this.initialState.documentos,
    });
  };

  addCantidadLote = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      cantidadesLotes = [...this.state.cantidades_lotes],
      productoSGI = { ...this.state.producto_sgi },
      productosValidadosListados = [...this.state.productos_validados_listados];

    if (!cantidadLote.cantidad) {
      this.validateSingleError("cantidad", "Ingrese cantidad.");
    }

    if (cantidadLote.cantidad === 0) {
      this.validateSingleError("cantidad", "La cantidad debe ser mayor a 0.");
    }

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (cantidadLote.cantidad && cantidadLote.lote) {
      // validamos que el lote a ingresar no se encuentra en la lista de lotes ya listados
      if (cantidadesLotes.find((obj) => obj.lote === cantidadLote.lote)) {
        Swal.fire({
          icon: "warning",
          title: "¡Atención!",
          text: `El lote ${cantidadLote.lote} ya se encuentra listado`,
          timer: 5000,
        });
        this.validateSingleError("lote", "Lote ya listado.");
      } else {
        // calculamos cantidad de cgi con las que se quieren ingresar
        let cantidadLoteInt = parseInt(cantidadLote.cantidad),
          cantidadSGI = parseInt(productoSGI.cantidad),
          cantidadRestante = 0;

        if (cantidadSGI === 0) {
          Swal.fire({
            icon: "warning",
            title: "¡Atención!",
            text: `El lote ${cantidadLote.lote} cuenta con 0 existencias actualmente.`,
            timer: 5000,
          });
        } else {
          cantidadRestante = cantidadSGI - cantidadLoteInt;

          if (cantidadRestante < 0) {
            Swal.fire({
              icon: "warning",
              title: "¡Atención!",
              text: `El lote ${cantidadLote.lote} sólo cuenta con ${cantidadSGI} existencias actualmente.`,
              timer: 5000,
            });
          } else {
            productoSGI.cantidad = cantidadRestante;

            productoSGI["cantidad_solicitada"] = cantidadLoteInt;
            cantidadLote["fecha_fabricacion"] = productoSGI.fecha_fabricacion
              .substr(0, 10)
              .split("-")
              .reverse()
              .join("/");
            cantidadLote["vencimiento_lote"] = productoSGI.vencimiento_lote
              .substr(0, 10)
              .split("-")
              .reverse()
              .join("/");

            cantidadesLotes.push(cantidadLote);
            productosValidadosListados.push(productoSGI);

            this.setState({
              cantidades_lotes: cantidadesLotes,
              // cantidad_lote: this.initialState.cantidad_lote,
              // producto_sgi: this.initialState.productoSGI,
              productos_validados_listados: productosValidadosListados,
            });
          }
        }
      }
    }
  };

  removeCantidadLote = (evt) => {
    let cantidadesLotes = [...this.state.cantidades_lotes],
      productosValidadosListados = [...this.state.productos_validados_listados];

    cantidadesLotes.splice(evt.target.id, 1);
    productosValidadosListados.splice(evt.target.id, 1);

    this.setState({
      cantidades_lotes: cantidadesLotes,
      productos_validados_listados: productosValidadosListados,
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors) => {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 5000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  handleCantidadLote = (evt) => {
    let inputName = evt.target.name,
      inputValue = evt.target.value,
      cantidadLote = { ...this.state.cantidad_lote },
      producto_valido = this.state.producto_valido,
      productoSGI = { ...this.state.producto_sgi };

    if (inputName === "cantidad") {
      if (this.checkPositiveIntegers(inputValue)) {
        // limpamos errores si es que los hay
        this.cleanErrorsValidation(inputName);
        cantidadLote.cantidad = inputValue;

        if (parseInt(inputValue) > parseInt(productoSGI.cantidad)) {
          document.getElementById("cantidad-error").style.display = "block";
          document.getElementById(
            "cantidad-error"
          ).innerText = `Este lote solo cuenta con ${productoSGI.cantidad} existencias.`;
          document.getElementById("cantidad").classList.add("is-invalid");
        } else {
          // limpamos errores si es que los hay
          this.cleanErrorsValidation("cantidad");
        }
        this.setState({ cantidad_lote: cantidadLote });
      }
    }

    if (inputName === "lote") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputName);
      cantidadLote.lote = inputValue.toUpperCase();

      if (producto_valido) {
        cantidadLote.cantidad = "";
      }

      this.setState({
        cantidad_lote: cantidadLote,
        producto_valido: this.initialState.producto_valido,
        producto_sgi: this.initialState.producto_sgi,
      });
    }
  };

  handleChangeTipoDocumento = (evt) => {
    this.setState({ tipo_documento_id: evt.target.value });
  };

  handleFile = (e) => {
    this.cleanErrorsValidation("tipo_documento");

    let file = e.target.files[0],
      tipo_documentos = this.state.tipo_documentos,
      tipo_documento_id = this.state.tipo_documento_id;

    /**
     * file
     * name: "REF-004-21.pdf"
     * size: 2356
     * type: "application/pdf"
     * webkitRelativePath: ""
     */
    let ext = file.type.split("/")[1];
    let carga = [];
    var reader = new FileReader();

    let nom_tdocumento = "";
    for (let i in tipo_documentos) {
      if (tipo_documentos[i].id === tipo_documento_id) {
        nom_tdocumento = tipo_documentos[i].descripcion;
        break;
      }
    }

    let data = {
      nombre: file.name,
      type: ext,
      archivo: e.name,
      tipo_documento_id: tipo_documento_id,
      tipo_documento: nom_tdocumento,
    };

    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.data = reader.result;
      };
      carga.push(data);
    }

    this.addDocument(carga);
  };

  addDocument = (documento) => {
    let doc = documento[0];
    let pa = [...this.state.documentos];

    for (let i in this.state.documentos) {
      if (pa[i].nombre === doc.nombre) {
        Swal.fire({
          title: "Atención",
          text: "Ya cuenta con este documento en su lista.",
        });
        return;
      }
    }

    pa.push(doc);
    this.setState({
      documentos: pa,
    });

    //tengo que quitar el documento del select
    let lista = [...this.state.tipo_documentos];
    for (let i in this.state.tipo_documentos) {
      if (lista[i].id === doc.tipo_documento_id) {
        lista.splice(parseInt(i), 1);
        break;
      }
    }
    this.setState({ tipo_documentos: lista });
  };

  removeDocumento = (e) => {
    let id = e.target.getAttribute("data-tipo_documento_id");
    let descripcion = e.target.getAttribute("data-descripcion");

    let lista = [...this.state.documentos];
    lista.splice(e.target.id, 1);
    this.setState({ documentos: lista });

    //agregamos de nuevo en el select
    let array = [];
    let obj_tipo_documento = {
      id: id,
      descripcion: descripcion,
    };

    array.push(obj_tipo_documento);
    this.setState({ tipo_documentos: array });
  };

  /*********** Funciones ***********/

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegers = (str) => {
    let regex = /^[1-9]\d{0,6}$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  //funcion para cerrar el modal con x
  closeModal = () => {
    Swal.fire({
      icon: "question",
      title: "¿Seguro que desea salir del formulario?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          modalState: false,
          workingModal: true,
          bitacora_movimiento: "",
        });
        this.resetStates();
      }
    });
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/movimientos-productos/egresos">
              Movimiento productos
            </Link>
          </li>
          <li className="breadcrumb-item">Egresos</li>
        </ol>
        <h1 className="page-header">Egreso productos</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    EGRESOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    EGRESOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="establecimiento_envia">
                            Establecimiento envía:
                          </label>
                          <div className="form-group">
                            <input
                              id="establecimiento_envia"
                              name="establecimiento_envia"
                              onChange={this.handleSearch}
                              placeholder="Ingrese establecimiento"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="actividad_envia">
                            Actividad envía:
                          </label>
                          <select
                            name="actividad_envia"
                            id="actividad_envia"
                            className="form-control"
                            onChange={this.handleSearch}
                            placeholder="Ingrese actividad"
                          >
                            <option value="">Seleccione actividad</option>
                            {this.state.cat_actividad.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="establecimiento_recibe">
                            Establecimiento recibe:
                          </label>
                          <input
                            id="establecimiento_recibe"
                            name="establecimiento_recibe"
                            onChange={this.handleSearch}
                            placeholder="Ingrese establecimiento"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="actividad_recibe">
                            Actividad recibe:
                          </label>
                          <select
                            name="actividad_recibe"
                            id="actividad_recibe"
                            className="form-control"
                            onChange={this.handleSearch}
                            placeholder="Ingrese actividad"
                          >
                            <option value="">Seleccione actividad</option>
                            {this.state.cat_actividad.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="folio_movimiento">
                            Folio movimiento:
                          </label>
                          <input
                            id="folio_movimiento"
                            name="folio_movimiento"
                            placeholder="Ingrese folio"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="estatus">Estado:</label>
                          <select
                            name="estatus"
                            id="estatus"
                            className="form-control"
                            onChange={this.handleSearch}
                          >
                            <option value="">Seleccione estatus</option>
                            <option value="5">ACEPTADA</option>
                            <option value="9">EN ESPERA SINAIP</option>
                            <option value="15">EN ESPERA MOVIMIENTO</option>
                            <option value="4">RECHAZADA</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="fecha_solicitud">
                            Fecha de solicitud:
                          </label>
                          <input
                            type="date"
                            name="fecha_solicitud"
                            onChange={this.handleSearch}
                            id="fecha_solicitud"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() =>
                              this.setListaSolicitudesMovimientoProductos(1)
                            }
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>

                      {/* <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-blue w-100"
                              title="Limpiar"
                              onClick={this.cleanSearch}
                            >
                              <i className="fas fa-trash-alt"></i> Limpiar
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </fieldset>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO MOVIMIENTOS</th>
                        <th className="text-center">ESTABLECIMIENTO ENVÍA</th>
                        <th className="text-center">ACTIVIDAD ENVÍA</th>
                        <th className="text-center">ESTABLECIMIENTO RECIBE</th>
                        <th className="text-center">ACTIVIDAD RECIBE</th>
                        <th className="text-center">FECHA SOLICITUD</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center">FECHA RESPUESTA</th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.solicitudes &&
                      this.state.solicitudes.length > 0 ? (
                        this.state.solicitudes.map((sol) => (
                          <tr key={sol.id}>
                            <td className="text-center">
                              {sol.folio_movimiento}
                            </td>
                            <td className="text-center">
                              {sol.establecimiento_envia_nombre}
                            </td>
                            <td className="text-center">
                              {sol.actividad_envia["descripcion"]}
                            </td>
                            <td className="text-center">
                              {sol.establecimiento_recibe_nombre}
                            </td>
                            <td className="text-center">
                              {sol.actividad_recibe["descripcion"]}
                            </td>
                            <td className="text-center">
                              {sol.fecha_solicitada}
                            </td>
                            <td className="text-center">{sol.tramite}</td>
                            <td className="text-center">
                              {sol.fecha_respuesta
                                ? sol.fecha_respuesta
                                    .substr(0, 10)
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              {!sol.formulario_envio && sol.acepto === "1" ? (
                                <div className="btn-group">
                                  <button
                                    onClick={this.openModalForm}
                                    id={sol.id}
                                    title="LLenar formulario para movimiento de productos"
                                    className="btn bg-gradient-green"
                                  >
                                    <i id={sol.id} className="fas fa-list"></i>
                                  </button>
                                </div>
                              ) : sol.formulario_acepta === "1" &&
                                sol.acepto === "1" ? (
                                <div className="btn-group">
                                  <button
                                    onClick={this.openModalInfoForm}
                                    id={sol.id}
                                    title="Ver información del movimiento"
                                    className="btn bg-gradient-blue"
                                  >
                                    <i id={sol.id} className="fas fa-eye"></i>
                                  </button>
                                </div>
                              ) : null}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No se encontraron resultados
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaSolicitudesMovimientoProductos(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.setListaSolicitudesMovimientoProductos(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.setListaSolicitudesMovimientoProductos(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.setListaSolicitudesMovimientoProductos(
                              this.state.paginas
                            );
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaMovimientosProducutosPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
          <Modal
            isOpen={this.state.modalState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "85%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={() => {
                this.closeModal();
              }}
              className="text-center"
            >
              {this.state.bitacora_movimiento
                ? `Folio: ${this.state.bitacora_movimiento.folio_movimiento}`
                : null}
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.handleSubmit} id="electronic-prescription">
                <MoveForm
                  state={this.state}
                  handleCantidadLote={this.handleCantidadLote}
                  handleProductChange={this.handleProductChange}
                  handlePresentationChange={this.handlePresentationChange}
                  handleNumFacturaChange={this.handleNumFacturaChange}
                  addCantidadLote={this.addCantidadLote}
                  removeCantidadLote={this.removeCantidadLote}
                  verifyProduct={this.verifyProduct}
                  handleFile={this.handleFile}
                  addDocument={this.addDocument}
                  removeDocumento={this.removeDocumento}
                  handleChangeTipoDocumento={this.handleChangeTipoDocumento}
                  handleVistaPrevia={this.handleVistaPrevia}
                  handleCloseVistaPrevia={this.handleCloseVistaPrevia}
                  workingModal={this.state.workingModal}
                />
              </form>
            </ModalBody>
            {/* <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-danger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter> */}
          </Modal>

          <Modal
            isOpen={this.state.modalInfoState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "80%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={() => {
                this.setState({
                  modalInfoState: false,
                  workingModal: true,
                  bitacora_movimiento: "",
                });
                this.resetStates();
              }}
              className="text-center"
            >
              {this.state.bitacora_movimiento
                ? `Folio: ${this.state.bitacora_movimiento.folio_movimiento}`
                : null}
            </ModalHeader>
            <ModalBody>
              <InfoForm
                bitacora_movimiento={this.state.bitacora_movimiento}
                workingModal={this.state.workingModal}
                handlePrevia={this.handlePrevia}
              />
            </ModalBody>
            {/* <ModalFooter>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        onClick={this.handleModalCloseBtn}
                        className="btn btn-danger float-right"
                      >
                        Regresar
                      </button>
                    </div>
                  </div>
                </div>
              </ModalFooter> */}
          </Modal>
          <div className={this.state.previa_form ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url_form}
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({
                      previa_form: this.initialState.previa,
                      previa_url_form: this.initialState.previa_url_form,
                    });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url_form + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductMovementsExit;
